var map = {
	"./Ellipse_active.png": 116,
	"./Ellipse_hover.png": 117,
	"./Ellipse_normal.png": 118,
	"./access_denied.jpg": 95,
	"./alert_bell.svg": 119,
	"./backgroung_tansparent.png": 120,
	"./bank-line.svg": 96,
	"./bank.svg": 121,
	"./bankaccount.png": 97,
	"./banking_api.png": 122,
	"./bankupload.png": 123,
	"./banner-top.jpg": 124,
	"./banner_one.png": 125,
	"./bg.jpg": 126,
	"./bgloader.svg": 127,
	"./check.png": 85,
	"./circletick.png": 128,
	"./copy.png": 129,
	"./customer_support.png": 130,
	"./easy_intagration.png": 131,
	"./error.png": 86,
	"./excro-logo.svg": 39,
	"./eye.svg": 132,
	"./eye_close_icon.svg": 25,
	"./eye_icon.svg": 26,
	"./filter.png": 133,
	"./folder.png": 134,
	"./fp_close.png": 135,
	"./fundtrans.png": 136,
	"./gr_custom-inputs.png": 137,
	"./gray_dummy_image.svg": 138,
	"./headphone.svg": 139,
	"./images.png": 84,
	"./logout.svg": 140,
	"./lowest_trans_rate.png": 141,
	"./mail.svg": 142,
	"./maximum_payment.png": 143,
	"./menu.svg": 144,
	"./onboarding.png": 145,
	"./paper_work.png": 146,
	"./payment_api.png": 147,
	"./pdf.png": 83,
	"./profile.svg": 148,
	"./report.png": 149,
	"./right_arrow.svg": 150,
	"./rugr_white_logo.svg": 151,
	"./sample-csv.csv": 152,
	"./sample-seperate-bank.csv": 153,
	"./security/auth-app.png": 154,
	"./security/circle-check-solid.svg": 98,
	"./security/email-verify.png": 155,
	"./security/mobile-verify.png": 156,
	"./time-info.png": 87,
	"./transaction.png": 157,
	"./upi-new.png": 158,
	"./upi.png": 159,
	"./upload-icon.png": 160,
	"./upload.png": 88,
	"./uploadfile.png": 99,
	"./usermanagement.png": 161,
	"./virtual.png": 162,
	"./vpa_api.png": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;